<template>
  <v-layout wrap>
    <v-flex xs12 pa-2>
      <v-toolbar color="grey lighten-2" height="42" dense flat>
          <v-toolbar-title class="ml-1 equip-text">{{ currentLabels.employee }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <span class="equip-text">{{ currentLabels.present }} {{ employee.length }} {{ currentLabels.man }} | </span>
          <span class="ml-2 equip-text">{{ currentLabels.manager }} {{ managerName }}</span>
      </v-toolbar> 
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      managerName: ''
    }
  },
  computed:{ 
    ...mapState([
      'currentLabels',
      'employee'
    ])
  },
  created () {    
    this.getManager()
  },
  beforeDestroy () {
  },
  methods: {
    getManager () {
      this.employee.find( e => {
        if (e.Manager === '1') {
          this.managerName = e.Name
        }
      })
    }
  }
}
</script>